/**
 * Created by mmaillot on 7/21/16.
 */

import Service from "../../services/Service";
import Logger from "../../utils/Logger";
import EQError from "../../utils/EQError";
import DateUtil from "../../utils/DateUtil";

import MscoreStepPersist from "../../script/executors/mscore/persistence/MscoreStepPersist"

export const CONFIG_SUCCESS = 0;
export const CONFIG_UPTODATE = 1;
export const CONFIG_FAILED = 2;

export default class ConfigService extends Service {

    /**
     *
     * @param {ConfigWebService} webservice
     * @param {ConfigConverter} converter
     * @param {ConfigParser} parser
     * @param {ConfigPersist} persistence
     */
    constructor(webservice, converter, parser, persistence) {
        Logger.log('Configuration init');
        super();

        this.webservice = webservice;
        this.converter = converter;
        this.parser = parser;
        this.persistence = persistence;

        this.migration();

        this.currentConfig = this.persistence.loadConfig();
        this.nextCheckDate = this.persistence.loadNextCheckDate() || DateUtil.getCurrentTimestamp();

        // mScore best server
        this.mscoreStepPersist = new MscoreStepPersist();
    }

    /**
     * Init the service with a callback and a coupon.
     *
     * @param callback
     * @param coupon
     */
    init(callback = null, coupon = null) {
        if (DateUtil.getCurrentTimestamp() >= this.nextCheckDate) {
            this.update(callback, coupon);
        } else {
            // Config cache:
            callback(CONFIG_UPTODATE, null);
        }
    }

    /**
     * Update the configuration with parameters
     * No check on date is done on this method.
     *
     * @param callback
     * @param coupon
     * @returns {Promise} A promise
     */
    update(callback = null, coupon = null) {
        Logger.log("Updating config");
        // Fix EWA-38 Load the last coupon used from storage if no coupon set
        return this.webservice.get(this.currentConfig, this.getOrUpdateCoupon(coupon))
            .then(this.converter.convert)
            .then(this.parser.parse)
            .then((config) => {
                if (this.currentConfig
                    && this.currentConfig.confVersion == config.confVersion
                    && this.currentConfig.groupId == config.groupId
                    && this.currentConfig.campaignId == config.campaignId) {
                    if (callback) callback(CONFIG_UPTODATE, null);
                } else {

                    Logger.log('New config');
                    this.saveConfig(config);
                    this.saveNextCheckDate(config);

                    this.configurationUpdated();

                    // Config successfully updated
                    if (callback) callback(CONFIG_SUCCESS, null);
                }
            })
            .catch(function (error) {
                // If 304 error (server not modified), set up to date callback
                if ((error instanceof EQError) && error.httpError && (error.code == 304)) {
                    // Config up to date
                    if (callback) callback(CONFIG_UPTODATE, null);
                } else {
                    Logger.log(error);
                    // Config failed
                    if (callback) callback(CONFIG_FAILED, error);
                }
            });
    }

    /**
     * This method is used to set (and store) the configuration
     *
     * @param {Config} config
     * @returns {Promise}
     */
    saveConfig(config) {
        this.currentConfig = config;
        Logger.log(this.currentConfig);
        this.persistence.saveConfig(config, this.webservice.getWebserviceVersion());
    }

    /**
     * This method is used to set (and store) the next configuration check timestamp
     * depending on the configuration
     *
     * @param config
     */
    saveNextCheckDate(config) {
        Logger.log('Saving next check date');
        let nextCheckTimestamp;
        if (config.refreshConfigInterval) {
            nextCheckTimestamp = DateUtil.getCurrentTimestamp() + config.refreshConfigInterval;
        } else {
            nextCheckTimestamp = DateUtil.getCurrentTimestamp();
            Logger.log('Refresh config interval not set');
        }
        Logger.log(nextCheckTimestamp);
        this.nextCheckDate = nextCheckTimestamp;
        this.persistence.saveNextCheckDate(nextCheckTimestamp);

    }

    /**
     * This method is used to set (and store) the current coupon used to retrieve config from server
     *
     * @param {string|null} coupon
     *
     * @return {string|null} coupon to used to update config
     */
    getOrUpdateCoupon(coupon = null) {
        Logger.log('Saving current coupon');
        if (coupon != null) {
            // Update the current coupon
            this.coupon = coupon;
            this.persistence.saveCoupon(coupon);
            return coupon;
        }
        // If no coupon provided, get with the last coupon
        return this.persistence.loadCoupon();
    }

    /**
     * Check if web service version has been upgraded
     *
     * @return {boolean} true if configuration should be re-downloaded, else false
     */
    isConfigurationOutdated() {
        let cacheVersion = this.persistence.loadVersion();
        let appVersion = this.webservice.getWebserviceVersion();
        return cacheVersion != appVersion?true:false;
    }

    /**
     * Do some configuration migration tasks
     */
    migration() {
        // In this case, configuration version has changed, and cache need to be cleared to re-download valid configuration
        if (this.isConfigurationOutdated()) {
            Logger.log('Configuration outdated, cleaning configuration stuff');
            this.persistence.clearConfigurationData();
        }
    }

    /**
     * Called when configuration is updated
     */
    configurationUpdated() {
        // Clean best mScore servers
        Logger.log('Cleaning mScore best servers');
        new this.mscoreStepPersist.clean();
    }
}


// WEBPACK FOOTER //
// ./js/core/configuration/service/ConfigService.js